import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const LegendGradient = () => {
  const theme = useTheme();
  const gradientStops = useMemo(() => {
    return [
      { pct: 0, color: theme.palette.success.main },
      { pct: 50, color: theme.palette.warning.main },
      { pct: 100, color: '#d50000' },
    ];
  }, [theme]);
  const gradientCss = useMemo(
    () => `linear-gradient(to right, ${gradientStops.map(s => `${s.color} ${s.pct}%`).join(', ')})`,
    [gradientStops]
  );
  const labelColors = useMemo(
    () => ({
      start: theme.palette.getContrastText(gradientStops[0].color),
      end: theme.palette.getContrastText(gradientStops[gradientStops.length - 1].color),
    }),
    [theme, gradientStops]
  );

  return (
    <Box sx={{ width: '100%', mb: 1.5 }}>
      <Box
        sx={{
          width: '100%',
          height: 14,
          background: gradientCss,
          borderRadius: 1,
          position: 'relative',
          mb: 0.25,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        {[
          { mark: 0, color: labelColors.start },
          { mark: 100, color: labelColors.end },
        ].map(({ mark, color }) => (
          <Typography
            key={mark}
            variant='caption'
            sx={{
              position: 'absolute',
              left: `${mark}%`,
              top: '50%',
              transform: `translate(${mark === 0 ? '2px' : 'calc(-100% - 2px)'}, -50%)`,
              lineHeight: 1,
              fontWeight: 'bold',
              color,
            }}
          >
            {mark}%
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default LegendGradient;
